import { css } from '@emotion/react'

export const datePickerStyles = css`
  .react-datepicker {
    font-family: unset;
    border: unset;
  }
  
  .react-datepicker__month-container {
    padding: var(--space-3, 12px);
  }
  
  .react-datepicker__header {
    background: unset;
    padding: unset;
    border-bottom: none;
  }
  
  .react-datepicker__day-names {
    display: flex;
    padding: var(--space-1, 5px) 0px;
    align-items: flex-start;
    align-self: stretch;
    justify-content: space-around;
    margin-top: var(--space-3, 12px);
    margin-bottom: var(--space-3, 12px);
  }
  
  .react-datepicker__day-name {
    text-transform: uppercase;
    text-align: center;
    margin: unset;
    font-size: var(--fontSizes-xs, 13px);
    font-style: normal;
    font-weight: var(--fontWeights-semibold, 600);
    line-height: 120%;
    color: var(--colors-chakra-subtle-text);
  }
  
  .react-datepicker__month {
    margin: unset;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
  }
  
  .react-datepicker__week {
    display: flex;
    padding: var(--space-1, 4px) 0px;
    align-items: flex-start;
    align-self: stretch;
  }
  
  .react-datepicker__day {
    color: var(--colors-chakra-body-text);
    text-align: center;
    margin-right: unset;
    margin-left: unset;
    font-size: var(--fontSizes-sm, 14px);
    font-style: normal;
    font-weight: var(--fontWeights-normal, 400);
    line-height: 150%;
    padding: var(--space-1-5, 6px) 0.429px var(--space-1, 5px) 0px;
    justify-content: center;
    align-items: center;
    width: 39px;
  }
  
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    border-radius: inherit;
    background-color: inherit;
    color: inherit;
  }
  
  .react-datepicker__day--in-selecting-range:not(
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--in-range
  ),
  .react-datepicker__month-text--in-selecting-range:not(
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--in-range
  ),
  .react-datepicker__quarter-text--in-selecting-range:not(
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--in-range
  ),
  .react-datepicker__year-text--in-selecting-range:not(
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--in-range
  ) {
    background-color: var(--colors-primary-bg);
    color: var(--colors-primary);
  }
  
  .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--range-start:not(.react-datepicker__day--in-range),
  .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range {
    border-radius: var(--radii-md) !important;
    background-color: var(--colors-primary) !important;
    color: var(--colors-white) !important;
  }
  
  .react-datepicker__day--range-start.react-datepicker__day--in-range {
    background-color: var(--colors-primary) !important;
    color: var(--colors-white) !important;
    border-radius: var(--radii-md) 0px 0px var(--radii-md) !important;
  }
  
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    background-color: var(--colors-primary);
    color: var(--colors-chakra-inverse-text);
  }
  
  .react-datepicker__day:not([aria-disabled='true']):hover {
    background-color: var(--colors-primary);
    color: var(--colors-white);
  }
  
  .react-datepicker__day:not([aria-disabled='true']):active {
    background-color: var(--colors-chakra-subtle-bg);
  }
  
  .react-datepicker__day--in-range {
    background: var(--colors-primary-bg);
    color: var(--colors-primary);
    border-radius: 0;
  }
  
  .react-datepicker__day:not([aria-disabled='true'], .react-datepicker__day--in-range):hover {
    border-radius: var(--radii-base, 0.3rem);
  }
  
  .react-datepicker__day--selected {
    color: var(--colors-chakra-inverse-text);
  }
  
  .react-datepicker__day--range-end {
    border-radius: 0px var(--radii-md) var(--radii-md) 0px;
    background: var(--colors-primary);
    color: var(--colors-chakra-inverse-text);
  }
  
  .react-datepicker__day--selected:not([aria-disabled='true']):hover,
  .react-datepicker__day--range-end:not([aria-disabled='true']):hover {
    background-color: var(--colors-primary-fg);
    color: var(--colors-chakra-inverse-text);
  }
  
  .react-datepicker__day--selected:not([aria-disabled='true']):active,
  .react-datepicker__day--range-end:not([aria-disabled='true']):active {
    background-color: var(--colors-primary-fg);
  }
  
  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end) {
    background-color: var(--colors-primary-bg);
  }
  
  .react-datepicker__day--disabled {
    color: var(--colors-chakra-subtle-text);
  }
  
  .react-datepicker__day--outside-month {
    color: transparent;
    pointer-events: none;
    background-color: transparent;
  }
  
  .react-datepicker__day--today:not(.react-datepicker__day--outside-month) {
    font-weight: var(--fontWeights-semibold, 600);
  }
  
  .react-datepicker__day--today:not(.react-datepicker__day--outside-month) {
    color: var(--colors-primary-fg);
  }
  
  .react-datepicker__day--today.react-datepicker__day--in-range.react-datepicker__day--range-end,
  .react-datepicker__day--today.react-datepicker__day--in-range.react-datepicker__day--range-start,
  .react-datepicker__day--today.react-datepicker__day--selecting-range-start.react-datepicker__day--selecting-range-end {
    color: var(--colors-chakra-inverse-text);
  }
  
  .react-datepicker__day--today:not(.react-datepicker__day--in-range){
    background-color: transparent;
  }
  
  .react-datepicker__day--today.react-datepicker__day--selecting-range-start,
  .react-datepicker__day--today.react-datepicker__day--selecting-range-end,
  .react-datepicker__day--today.react-datepicker__day--selected {
    background-color: var(--colors-primary);
    color: var(--colors-chakra-inverse-text);
  }
` 
